import hasProp from './hasProp';

/**
 * Determines if the passed user is in the beta group.
 *
 * @param {Object} user The user data object.
 *
 * @returns {boolean} True is user is in beta group.
 */
export const isUserBeta = user => {
	return (
		(hasProp(user, 'inBeta') && user.inBeta) ||
		(hasProp(user, 'beta') && user.beta && user.beta.enabled)
	);
};

/**
 * Determines if the passed user is in the AM Team group.
 *
 * @param {Object} user The user data object.
 *
 * @returns {boolean} True is user is in AM Team group.
 */
export const isUserAmTeam = user => {
	return hasProp(user, 'isAmTeam') && user.isAmTeam;
};

/**
 * Determines if the passed user is a god-moded AM Team member.
 *
 * @since 0.1.8
 *
 * @param {Object} user The user data object.
 *
 * @returns {boolean} True is user is a god-moded AM Team member.
 */
export const isUserAmTeamGodMode = user => {
	return hasProp(user, 'amgm') && user.amgm;
};
